webpackJsonp([25001959206243],{

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _criteria = __webpack_require__(43);
	
	var _criteria2 = _interopRequireDefault(_criteria);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _criteria2.default;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-criteria-202526-js-50259963848ed3427d4e.js